// 検索タグリスト
const Tag = [
  {
    value: 'contracted',
    tag: '成約非表示',
    type: 'flg',
  },
  {
    value: 'vacancy_sort_from',
    tag: '確認日',
    type: 'range',
    _value: 'vacancy_sort',
    unit: '',
  },
  {
    value: 'vacancy_sort_to',
    tag: '確認日',
    type: 'range',
    _value: 'vacancy_sort',
    unit: '',
  },
  {
    value: 'tmp_save',
    tag: '一時保存のみ',
    type: 'flg',
  },
  {
    value: 'id',
    tag: '物件ID',
    type: 'text',
  },
  {
    value: 'control_no',
    tag: '物件管理番号',
    type: 'text',
  },
  {
    value: 'matter_no',
    tag: '案件No',
    type: 'text',
  },
  {
    value: 'property_name',
    tag: '物件名またはカナ',
    type: 'text',
  },
  {
    value: 'room_no',
    tag: '部屋番号',
    type: 'text',
  },
  {
    value: 'address_str',
    tag: '住所',
    type: 'text',
  },
  {
    value: 'address_else1',
    tag: '住居表示',
    type: 'text',
  },
  {
    value: 'station_name',
    tag: '駅名',
    type: 'text',
  },
  {
    value: 'm_b_type',
    tag: '物件種別',
    type: 'checkboxGroup',
  },
  {
    value: 'mi_sale_state',
    tag: '販売状態',
    type: 'select',
    str: 'mi_sale_state_str',
  },
  {
    value: 'm_vacant_type',
    tag: '現況',
    type: 'select',
    str: 'm_vacant_type_str',
  },
  {
    value: 'f_owner_change',
    tag: 'オーナーチェンジ',
    type: 'flg',
  },
  {
    value: 'b_price_from',
    tag: '物件価格',
    type: 'range',
    _value: 'b_price',
    unit: '万円',
  },
  {
    value: 'b_price_to',
    tag: '物件価格',
    type: 'range',
    _value: 'b_price',
    unit: '万円',
  },
  {
    value: 'yield_from',
    tag: '満室時利回り',
    type: 'range',
    _value: 'yield',
    unit: '%',
  },
  {
    value: 'yield_to',
    tag: '満室時利回り',
    type: 'range',
    _value: 'yield',
    unit: '%',
  },
  {
    value: 'income_price_from',
    tag: '満室時年間収入',
    type: 'range',
    _value: 'income_price',
    unit: '万円',
  },
  {
    value: 'income_price_to',
    tag: '満室時年間収入',
    type: 'range',
    _value: 'income_price',
    unit: '万円',
  },
  {
    value: 'magnification_from',
    tag: '倍率（軍用地)',
    type: 'range',
    _value: 'magnification',
    unit: '倍',
  },
  {
    value: 'magnification_to',
    tag: '倍率（軍用地)',
    type: 'range',
    _value: 'magnification',
    unit: '倍',
  },
  {
    value: 'line_1',
    tag: '沿線・駅1：',
    type: 'line',
    _value: '1',
  },
  {
    value: 'line_2',
    tag: '沿線・駅2：',
    type: 'line',
    _value: '2',
  },
  {
    value: 'line_3',
    tag: '沿線・駅3：',
    type: 'line',
    _value: '3',
  },
  {
    value: 'walk_minutes_from',
    tag: '駅徒歩',
    type: 'range',
    _value: 'walk_minutes',
    unit: '分',
  },
  {
    value: 'walk_minutes_to',
    tag: '駅徒歩',
    type: 'range',
    _value: 'walk_minutes',
    unit: '分',
  },
  {
    value: 'bus_stop',
    tag: 'バス停名',
    type: 'text',
  },
  {
    value: 'water_supply_type',
    tag: '上水道',
    type: 'checkboxGroup',
  },
  {
    value: 'sewerage_type',
    tag: '下水道',
    type: 'checkboxGroup',
  },
  {
    value: 'gas_type',
    tag: 'ガス',
    type: 'checkboxGroup',
  },
  {
    value: 'f_power_source',
    tag: '動力電源',
    type: 'flg',
  },
  {
    value: 'f_electricity',
    tag: '電気',
    type: 'flg',
  },
  {
    value: 'f_all_electrification',
    tag: 'オール電化',
    type: 'flg',
  },
  {
    value: 'rank',
    tag: 'ランク',
    type: 'checkboxGroup',
  },
  {
    value: 'list_star',
    tag: 'マーク',
    type: 'checkboxGroup',
  },
  {
    value: 'transaction_form',
    tag: '取引形態',
    type: 'checkboxGroup',
  },
  {
    value: 'eacompany_name',
    tag: '元付業者名',
    type: 'text',
  },
  {
    value: 'eacompany_tel',
    tag: '元付業者TEL',
    type: 'text',
  },
  {
    value: 'eacompany_id',
    tag: '元付業者ID',
    type: 'text',
  },
  {
    value: 'image_num_from',
    tag: '画像数',
    type: 'range',
    _value: 'image_num',
    unit: '枚',
  },
  {
    value: 'image_num_to',
    tag: '画像数',
    type: 'range',
    _value: 'image_num',
    unit: '枚',
  },
  {
    value: 'panorama_num_from',
    tag: 'パノラマ画像数',
    type: 'range',
    _value: 'panorama_num',
    unit: '枚',
  },
  {
    value: 'panorama_num_to',
    tag: 'パノラマ画像数',
    type: 'range',
    _value: 'panorama_num',
    unit: '枚',
  },
  {
    value: 'f_video_url',
    tag: '動画URL',
    type: 'flg',
  },
  {
    value: 'charge_person',
    tag: '担当者1',
    type: 'text',
  },
  {
    value: 'listing_charge_person',
    tag: '掲載用担当者',
    type: 'text',
  },
  {
    value: 'created_at_from',
    tag: '作成日',
    type: 'range',
    _value: 'created_at',
    unit: '',
  },
  {
    value: 'created_at_to',
    tag: '作成日',
    type: 'range',
    _value: 'created_at',
    unit: '',
  },
  {
    value: 'updated_at_from',
    tag: '更新日',
    type: 'range',
    _value: 'updated_at',
    unit: '',
  },
  {
    value: 'updated_at_to',
    tag: '更新日',
    type: 'range',
    _value: 'updated_at',
    unit: '',
  },
  {
    value: 'last_updated_person',
    tag: '最終更新者',
    type: 'select',
    str: 'charge_person_str',
  },
  {
    value: 'room_charge_shop_list',
    tag: '担当店舗',
    type: 'shop',
    str: 'shop_arr',
  },
  {
    value: 'f_event_comment',
    tag: 'イベントコメント',
    type: 'flg',
  },
  {
    value: 'freetag_search_word_1',
    tag: 'フリータグ1',
    type: 'freetag_search_word',
    _value: '1',
  },
  {
    value: 'freetag_search_word_2',
    tag: 'フリータグ2',
    type: 'freetag_search_word',
    _value: '2',
  },
  {
    value: 'freetag_search_word_3',
    tag: 'フリータグ3',
    type: 'freetag_search_word',
    _value: '3',
  },
  {
    value: 'freetag_search_word_4',
    tag: 'フリータグ4',
    type: 'freetag_search_word',
    _value: '4',
  },
  {
    value: 'freetag_search_word_5',
    tag: 'フリータグ5',
    type: 'freetag_search_word',
    _value: '5',
  },
  {
    value: 'elementary_school',
    tag: '小学校',
    type: 'text',
  },
  {
    value: 'junior_high_school',
    tag: '中学校',
    type: 'text',
  },
  {
    value: 'right_of_site',
    tag: '敷地権利',
    type: 'select',
    str: 'right_of_site_str',
  },
  {
    value: 'land_area',
    tag: '土地面積',
    type: 'text',
    unit: '㎡以上',
  },
  {
    value: 'land_coverage_ratio',
    tag: '建ぺい率',
    type: 'text',
    unit: '％以上',
  },
  {
    value: 'land_capacity_ratio',
    tag: '容積率',
    type: 'text',
    unit: '％以上',
  },
  {
    value: 'floor',
    tag: '階建',
    type: 'text',
    unit: '階以上',
  },
  {
    value: 'floor_area',
    tag: '建物面積',
    type: 'text',
    unit: '㎡以上',
  },
  {
    value: 'build_y_from',
    tag: '築年数',
    type: 'build',
    _value: 'build',
  },
  {
    value: 'build_m_from',
    tag: '築年数',
    type: 'build',
    _value: 'build',
  },
  {
    value: 'build_y_to',
    tag: '築年数',
    type: 'build',
    _value: 'build',
  },
  {
    value: 'build_m_to',
    tag: '築年数',
    type: 'build',
    _value: 'build',
  },
  {
    value: 'f_new_building',
    tag: '新築',
    type: 'flg',
  },
  {
    value: 'floor_no',
    tag: '所在階',
    type: 'text',
    unit: '階以上',
  },
  {
    value: 'balcony_area',
    tag: 'バルコニー',
    type: 'text',
    unit: '㎡以上',
  },
  {
    value: 'number_of_rooms_from',
    tag: '間取り',
    type: 'house_plan',
    _value: 'number_of_rooms',
  },
  {
    value: 'number_of_rooms_to',
    tag: '間取り',
    type: 'house_plan',
    _value: 'number_of_rooms',
  },
  {
    value: 'mi_floor_plan_cd',
    tag: '間取り',
    type: 'house_plan',
  },
  {
    value: 'exclusive_area',
    tag: '専有面積',
    type: 'text',
    unit: '㎡以上',
  },
  {
    value: 'room_size',
    tag: 'DK／LDK',
    type: 'text',
    unit: '畳以上',
  },
  {
    value: 'parking_exist',
    tag: '駐車場',
    type: 'checkboxGroup',
  },
  {
    value: 'parking_fee_from',
    tag: '駐車場料金',
    type: 'range',
    _value: 'parking_fee',
    unit: '万円',
  },
  {
    value: 'parking_fee_to',
    tag: '駐車場料金',
    type: 'range',
    _value: 'parking_fee',
    unit: '万円',
  },
]

export default Tag
